export default "__VITE_ASSET__UFi8bzmD__"